import validator from 'validator';

// check if the string is a valid URL.

// options is an object which defaults to 
// {
//     "protocols":[
//        "http",
//        "https",
//        "ftp"
//     ],
//     "require_tld":true,
//     "require_protocol":false,
//     "require_host":true,
//     "require_port":false,
//     "require_valid_protocol":true,
//     "allow_underscores":false,
//     "host_whitelist":false,
//     "host_blacklist":false,
//     "allow_trailing_dot":false,
//     "allow_protocol_relative_urls":false,
//     "allow_fragments":true,
//     "allow_query_components":true,
//     "disallow_auth":false,
//     "validate_length":true
//  }
// require_protocol - if set as true isURL will return false if protocol is not present in the URL.
// require_valid_protocol - isURL will check if the URL's protocol is present in the protocols option.
// protocols - valid protocols can be modified with this option.
// require_host - if set as false isURL will not check if host is present in the URL.
// require_port - if set as true isURL will check if port is present in the URL.
// allow_protocol_relative_urls - if set as true protocol relative URLs will be allowed.
// allow_fragments - if set as false isURL will return false if fragments are present.
// allow_query_components - if set as false isURL will return false if query components are present.
// validate_length - if set as false isURL will skip string length validation (2083 characters is IE max URL length).
export const isURL = (url, obj) => {    
    const urlTemp = url.replace(/\/\*/, '/'); // This sentence is to replace an asterisk in order to validate realtive URLs (e.g "http://*sinexiar.com");
    return validator.isURL(urlTemp, { require_tld: false });
}

// Check if string of URL values are well formatted (separated by coma)
export const isURLsList = (arryOfUrl) => {

    if (arryOfUrl === null || arryOfUrl.length < 6){
      return false;
    }

    const urlList = arryOfUrl.split(',');

    for (let i = 0; i < urlList.length; i++) {
        const urlValue = urlList[i].trim();

        // If url address is not correct, then return false.
        if (isURL(urlValue) !== true){
            // console.log(urlValue + " is NOT valid!");
            return false;
        }
    }
    // If all url are well formatted return ture
    return true;
}

// isIP(str [, version])  - check if the string is an IP (version 4 or 6).
export const isIP = (iP) => {
    return validator.isIP(iP);
}

// check if the string is a valid port number.
export const isPort = (iP) => {
    return validator.isPort(iP);
}


// Check if a password is strong or not. Allows for custom requirements or scoring rules.
// If returnScore is true, then the function returns an integer score for the password rather than a boolean.
// Default options:
// {
//     "minLength":8,
//     "minLowercase":1,
//     "minUppercase":1,
//     "minNumbers":1,
//     "minSymbols":1,
//     "returnScore":false,
//     "pointsPerUnique":1,
//     "pointsPerRepeat":0.5,
//     "pointsForContainingLower":10,
//     "pointsForContainingUpper":10,
//     "pointsForContainingNumber":10,
//     "pointsForContainingSymbol":10
//  }
export const isStrongPassword = (password) => {
    return validator.isStrongPassword(password);
}

// Check if the string is an email.
// options is an object which defaults to:
// {
//     "allow_display_name":false,
//     "require_display_name":false,
//     "allow_utf8_local_part":true,
//     "require_tld":true,
//     "allow_ip_domain":false,
//     "domain_specific_validation":false,
//     "blacklisted_chars":"",
//     "host_blacklist":[]
//  }
// If allow_display_name is set to true, the validator will also match Display Name <email-address>. If require_display_name is set to true, the validator will reject strings without the format Display Name <email-address>. If allow_utf8_local_part is set to false, the validator will not allow any non-English UTF8 character in email address' local part. If require_tld is set to false, e-mail addresses without having TLD in their domain will also be matched. If ignore_max_length is set to true, the validator will not check for the standard max length of an email. If allow_ip_domain is set to true, the validator will allow IP addresses in the host part. If domain_specific_validation is true, some additional validation will be enabled, e.g. disallowing certain syntactically valid email addresses that are rejected by GMail. If blacklisted_chars receives a string, then the validator will reject emails that include any of the characters in the string, in the name part. If host_blacklist is set to an array of strings and the part of the email after the @ symbol matches one of the strings defined in it, the validation fails.
export const isEmail = (email) => {
    return validator.isEmail(email);
}

// Check phone number in any locale number
export const isMobilePhone = (mobile) => {
    return validator.isMobilePhone(mobile, 'any');
}


// Check if value is a number
export const isNumber = (numbrer) => {
    const pattern = new RegExp('^[0-9]+$');   
    return pattern.test(numbrer);
}

// check if the string contains only letters (a-zA-Z).
export const isAlpha = (value) => {
    const va= validator.isAlpha(value);
    return va;
}

// Check if the string contains only letters and numbers (a-zA-Z0-9).
export const isAlphanumeric = (value) => {
    
    return validator.isAlphanumeric(value);
}

// Check if value is an alphanumeric and accept space 
export const isAlphanumericSpace = (value) => {
    if (value.match(/^[a-z\d\-_\s]+$/i)) {
        return true;
    }
    return false;
}

// Check if value is valid in any alphabeticallanguage
export const isAlphabeticalFullName = (value) => {
    
    const pattern = new RegExp(/^([a-z ñáàâéèêíìîóòôúùûüç']{2,60})$/i);
    if (pattern.test(value)) {
        return true;
    }
    return false;
}


// Check if value is an alphanumeric with special character alowed as 
export const isAlphanumericWithSpecials = (value) => {
    
    if (value.match(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$/g)){// eslint-disable-line 
        return true;
    }
    return false;
}

// Regular Expresion Patter used to validate "username" format.
export const regexUserName = () => {
    return /^(?=.{8,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/;  // https://stackoverflow.com/questions/12018245/regular-expression-to-validate-username
}

// Regular Expresion Patter used to validate "first name" and "second name" format of a person.
export const regexStandardName = () => {
    return /^([a-z ñáàâéèêíìîóòôúùûüç']{2,30})$/i;
}

// Regular Expresion Patter used to validate "password" format.
export const regexPassword = () => {
    return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&'()*+,-.\/:;<=>?\\@[\]^_`{|}~]).{6,30}$/;// eslint-disable-line 
}

// Regular Expresion Patter used to validate a "number" format.
export const regexNumber = () => {
    return /^[0-9]*$/;
}

// Function to get a Date in format "yyyy-MM-ddThh:mm:ss-03:00"
export const getDateToISOString = () => {
    return new Date().toISOString();
}